import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import background from "../assets/img/upcoming-bg.png";
import "../assets/css/Upcomingtrips.css";

const UpcomingTrip = () => {
  const [tripDates, setTripDates] = useState([]);

  // ✅ Fetch and filter data from Google Sheet
  useEffect(() => {
    const sheetURL =
      "https://docs.google.com/spreadsheets/d/e/2PACX-1vQJB4XDn4cM60lvPxxVwBp8--5AHiSti_X9DNNSbnH_L1SnzodWZRsBM2E8wFUKbdIzsdBQMga5x-Dr/pub?output=csv";

    Papa.parse(sheetURL, {
      download: true,
      header: true,
      complete: function (results) {
        const rows = results.data;

        const allTrips = rows.map((row) => ({
          id: Number(row.id),
          // The CSV header is "id,travel," so the name is likely in the column with empty string key
          tourName: row[""] || row["name"] || row["Name"], 
        }));

        // ✅ Get first 4 trips
        const latestFour = allTrips.slice(0, 4);

        setTripDates(latestFour);
      },
    });
  }, []);

  // ✅ Helper function: format date as "DD Mon"
  const formatDate = (date) => {
    if (!date || isNaN(date)) return "";
    const d = new Date(date);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = d.getDate().toString().padStart(2, "0");
    return `${day} ${months[d.getMonth()]}`;
  };

  const containerStyle = {
    backgroundImage: `url(${background})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "5%",
  };

  // ✅ Static Images
  const imageUrls = [
    "images/union1.svg",
    "images/union1.svg",
    "images/union1.svg",
    "images/union1.svg",
  ];
  const imageUrls1 = [
    "images/ramar.png",
    "images/ramar.png",
    "images/ramar.png",
    "images/ramar.png",
  ];

  // ✅ Dynamic month labels
  const getMonthYear = (date) => {
    if (!date || isNaN(date)) return "";
    const d = new Date(date);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${months[d.getMonth()]} ${d.getFullYear()}`;
  };

  const startMonth = "";
  const endMonth = "";

  return (
    <>
      <div className="col-12 text-center upcoming-section" style={containerStyle}>
        <h2 className="district">
          <span>
            <img src="images/geo-fill 2.png" alt="geo" />
          </span>
          Our Next Trips
        </h2>
        <p className="district-para">Join With Us</p>

        <div className="image-container1 container">
          <div className="scroll-wrapper">
            {/* ✅ Top Row */}
            <div className="image-row1 container">
              {tripDates.map((trip, index) => (
                <div key={index} className="trip-item">
                  <div className={`text-wrapper1 ${index % 2 === 0 ? "odd_text" : "even_text"}`}>
                    <p className="date1">{trip.tourName}</p>
                  </div>

                  <div className={`image-wrapper1 ${index % 2 === 0 ? "even-index" : "odd"}`}>
                    <img src={imageUrls[index]} alt={`Trip ${index + 1}`} className="img1" />
                    <img
                      src={imageUrls1[index]}
                      alt={`Trip Icon ${index + 1}`}
                      className={`overlay-image ${index % 2 === 0 ? "even-index1" : "odd-index1"}`}
                    />
                  </div>
                </div>
              ))}
            </div>

            {/* ✅ Green Line & Location Pins */}
            <div className="container line-container">
              <div className="container1">
                <div className="Location">
                  <img src="images/location.svg" alt="Location Start" />
                </div>
                <img src="images/GreenLine.png" className="horizontal-line" alt="Line" />
                <div className="Location">
                  <img src="images/greenlocation.svg" alt="Location End" />
                </div>
              </div>

              <div className="container2">
                <div className="Location1">
                  <p className="date">{startMonth}</p>
                </div>
                <div className="Location2">
                  <p className="date">{endMonth}</p>
                </div>
              </div>
            </div>

            {/* ✅ Bottom Row */}
            <div className="image-row2 container">
              {tripDates.map((trip, index) => (
                <div key={index} className="trip-item">
                  <div className={`text-wrapper ${index % 2 === 0 ? "even_text" : "odd_text"}`}>
                    <p className="date1">{trip.tourName}</p>
                  </div>

                  <div className={`image-wrapper2 ${index % 2 === 0 ? "even" : "odd-index"}`}>
                    <img src={imageUrls[index]} alt={`Trip ${index + 1}`} className="img1" />
                    <img
                      src={imageUrls1[index]}
                      alt={`Trip Icon ${index + 1}`}
                      className={`overlay-image ${index % 2 === 0 ? "even-index1" : "odd-index1"}`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ✅ WhatsApp CTA */}
        <div className="Contact">
          <div className="whatsapp-section1">
            <a
              href="https://api.whatsapp.com/send/?phone=9585345454&text=Hi! I'm interested in your upcoming trips.&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button>Get More Details</button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingTrip;
